import EventFixturesList from "./EventFixturesList";
export default EventFixturesList;
